module.exports = __webpack_public_path__ + "assets/jisuan.4af1e177.svg";